import { useStoreMap } from 'effector-react'
import { driverModel } from '~/entities/Driver'
import { taxSystemEnumLabels } from '~/shared/config/constants'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { Label, Field } from './styled'

type IndividualEntrepreneurDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function IndividualEntrepreneurDrawer({
  isShow,
  onClose,
}: IndividualEntrepreneurDrawerProps) {
  const taxSystem = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getTaxSystem(),
  )
  const inn = useStoreMap(driverModel.$driver, (driver) => driver?.getInn())

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Label>Система налогообложения ИП</Label>
      <Field data-testid='passport-details-full-name'>
        {taxSystem ? taxSystemEnumLabels[taxSystem] : '-'}
      </Field>

      <Label>ИНН</Label>
      <Field data-testid='passport-details-passport-number'>{inn || '-'}</Field>
    </DrawerComponent>
  )
}
